import { Tooltip, useMantineTheme, TooltipProps } from '@mantine/core';
import { PropsWithChildren } from 'react';

interface Props {
	isDisabled?: boolean;
	label: TooltipProps['label'];
}

export const TooltipBox = ({ isDisabled, label, children }: PropsWithChildren<Props>) => {
	const theme = useMantineTheme();

	return (
		<Tooltip
			label={label}
			bg="white.0"
			p="0.25rem"
			radius="md"
			disabled={isDisabled}
			withinPortal
			style={{
				border: `1px solid ${theme.colors.gray[0]}`,
				boxShadow: '0px 8px 16px 0px #91969833',
			}}
		>
			{children}
		</Tooltip>
	);
};
